/** Account + subscription labels for fisher rows (matches dashboard metrics). */

export function getFisherSubscriptionStatus(row) {
  const endRaw = row.FisherEndDate ?? row.EndDate;
  if (!endRaw) {
    return { label: "Expired", tone: "danger" };
  }
  const end = new Date(endRaw);
  end.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (today > end) {
    return { label: "Expired", tone: "danger" };
  }
  const packageId = row.FisherPackageID ?? row.PackageID;
  if (packageId == null) {
    return { label: "Trial", tone: "indigo" };
  }
  return { label: "Running", tone: "teal" };
}

export function getFisherAccountStatus(row) {
  if (row.FisherDeletedAt || row.DeletedAt) {
    return { label: "Deleted", tone: "secondary" };
  }
  const active = row.FisherStatus === true || row.FisherStatus === 1;
  return active
    ? { label: "Active", tone: "success" }
    : { label: "Pending", tone: "warning" };
}

export function accountStatusBadgeClass(tone) {
  const map = {
    success: "border-success text-success",
    warning: "border-warning text-warning",
    danger: "border-danger text-danger",
    indigo: "border-primary text-primary",
    teal: "border-info text-info",
    secondary: "border-secondary text-secondary",
  };
  return map[tone] || "border-secondary text-secondary";
}
